// extracted by css-extract-rspack-plugin
export default {"ParentIssueTokenContainer":"parent-issue-token-module__ParentIssueTokenContainer__NJNpc","ParentIssueTokenMain":"parent-issue-token-module__ParentIssueTokenMain__R8oRH"};